import React, {useRef, useState} from 'react'
import {
  IconsBox,
  LeftBox,
  StyledLink,
  LinksBox,
  LogoBox,
  NavbarBox,
  RightBox,
  SearchBox,
  Icon,
  StyledInput,
  FloatingIcon,
  MenuBox,
  MenuIcon,
  MenuItem,
  StyledMenu,
  Divider,
  LoginBox,
} from './styles'
import {
  Link,
  Link as RouterLink,
  useLocation,
  useNavigate,
} from 'react-router-dom'
import DashboardIcon from '../../../images/icons/new-dashboard/dashboard-icon.svg'
import DashboardIconHover from '../../../images/icons/new-dashboard/dashboard-hover-icon.svg'
import MyCartIcon from '../../../images/icons/new-dashboard/cart-icon.svg'
import SearchIcon from '../../../images/icons/new-dashboard/search-icon.svg'
import AvatarIcon from '../../../images/icons/new-dashboard/avatar-icon.svg'
import AvatarIconHover from '../../../images/icons/new-dashboard/avatar-icon-hover.svg'
import MobileMenuIcon from '../../../images/icons/new-dashboard/mobile-menu-icon.svg'
import MobileMenuIconClose from '../../../images/icons/new-dashboard/menu-icon-close.svg'

import ManageSubscriptionIcon from '../../../images/icons/new-dashboard/manage-subscription-icon.svg'
import BillingHistoryIcon from '../../../images/icons/new-dashboard/billing-history-icon.svg'
import PaymentMethodIcon from '../../../images/icons/new-dashboard/payment-method-icon.svg'
import PasswordIcon from '../../../images/icons/new-dashboard/password-icon.svg'
import ExamStatusIcon from '../../../images/icons/new-dashboard/exam-status-icon.svg'
import UpdateProfileIcon from '../../../images/icons/new-dashboard/update-profile-icon.svg'
import HelpIcon from '../../../images/icons/new-dashboard/quiz-icon.svg'
import LogoutIcon from '../../../images/icons/new-dashboard/logout-icon.svg'

import Logo from '../../../images/logo-black.png'
import {useWindowDimensions} from '../../../hooks/useWindowDimensions'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Sidenav from '../Sidenav'
import {Menu} from '@mui/material'
import {useAuth} from '../../../components/AuthProvider'
import {LinkBox} from '../../../styles/global'
import {useAuth0} from '@auth0/auth0-react'
import {useSelector} from 'react-redux'
import {selectMember} from '../../../redux/members'

const View = () => {
  const [isSideMenuExpanded, setIsSideMenuExpanded] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const {isMobile} = useWindowDimensions()
  const [hover, setHover] = useState(false)
  const [hoverAvatar, setHoverAvatar] = useState(false)
  const [inputValue, setInputValue] = useState('')

  const {loginWithPopup} = useAuth0()
  const auth = useAuth()
  const location = useLocation()
  const navigate = useNavigate()

  const member = useSelector(selectMember)

  const userButtonRef = useRef() as React.RefObject<HTMLImageElement>

  const handleClick = () => {
    setIsMenuOpen(true)
  }

  const handleClose = () => {
    setIsMenuOpen(false)
  }

  const handleSearch = (event: any) => {
    event.preventDefault()
    if (inputValue) {
      navigate(`/search/results?search=${inputValue}`, {
        replace: true,
      })
    }
  }

  const masterAccess =
    (member?.groupAccounts &&
      member?.groupAccounts[0] &&
      member?.groupAccounts[0].admin) ||
    (member?.groupAccounts && member?.groupAccounts?.length === 0)

  const isCga = member?.groupId === 91

  return (
    <>
      <NavbarBox $isAuthenticated={auth.isAuthenticated}>
        <LeftBox>
          {isMobile && (
            <img
              src={isSideMenuExpanded ? MobileMenuIconClose : MobileMenuIcon}
              alt="Toggle menu"
              onClick={() => setIsSideMenuExpanded(!isSideMenuExpanded)}
              width={'16px'}
            />
          )}
          <LogoBox>
            <LinkBox component={RouterLink} to="/">
              <img src={Logo} alt="Black Spectacles" />
            </LinkBox>
          </LogoBox>
          {!isMobile && (
            <LinksBox>
              <StyledLink
                href="https://www.blackspectacles.com/pricing"
                target="_blank"
              >
                Individual Pricing
              </StyledLink>
              <StyledLink
                href="https://help.blackspectacles.com/en/"
                target="_blank"
              >
                Help
              </StyledLink>
            </LinksBox>
          )}
        </LeftBox>
        <RightBox>
          {!isMobile && (
            <SearchBox>
              <form onSubmit={handleSearch}>
                <StyledInput
                  placeholder="Search..."
                  onChange={e => setInputValue(e.target.value)}
                />
                <FloatingIcon
                  src={SearchIcon}
                  alt="Search"
                  onClick={handleSearch}
                />
              </form>
            </SearchBox>
          )}
          <IconsBox>
            {!isMobile ? (
              <>
                <LinkBox component={RouterLink} to="/">
                  <Icon
                    $isActive={location.pathname === '/'}
                    onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                  >
                    <img
                      src={
                        hover || location.pathname === '/'
                          ? DashboardIconHover
                          : DashboardIcon
                      }
                      alt="Dashboard"
                    />
                    <span>Dashboard</span>
                  </Icon>
                </LinkBox>
                {!auth.isAuthenticated && (
                  <LoginBox
                    onClick={() =>
                      loginWithPopup(
                        {
                          authorizationParams: {
                            redirect_uri: window.location.origin,
                          },
                        },
                        {
                          timeoutInSeconds: 360,
                        },
                      )
                    }
                  >
                    Login
                  </LoginBox>
                )}
              </>
            ) : (
              <>
                {!auth.isAuthenticated && (
                  <LoginBox
                    onClick={() =>
                      loginWithPopup(
                        {
                          authorizationParams: {
                            redirect_uri: window.location.origin,
                          },
                        },
                        {
                          timeoutInSeconds: 360,
                        },
                      )
                    }
                  >
                    Login
                  </LoginBox>
                )}
              </>
            )}
            {/* <Icon>
              <img src={NotificationsIcon} alt="Notifications" />
              <span>
                Notifications
              </span>
            </Icon>
            <Icon>
              <img src={MyCartIcon} alt="My Cart" />
              <span>
                My Cart
              </span>
            </Icon> */}

            {auth.isAuthenticated && (
              <>
                <Icon
                  ref={userButtonRef}
                  onClick={handleClick}
                  $isActive={isMenuOpen}
                  onMouseEnter={() => setHoverAvatar(true)}
                  onMouseLeave={() => setHoverAvatar(false)}
                >
                  <img
                    src={
                      hoverAvatar || isMenuOpen ? AvatarIconHover : AvatarIcon
                    }
                    alt="Account"
                  />
                  {isMobile && <ExpandMoreIcon />}
                  <span>Account</span>
                </Icon>
                <Menu
                  id="basic-menu"
                  anchorEl={userButtonRef.current}
                  open={isMenuOpen}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  <StyledMenu>
                    {isMobile && (
                      <>
                        <Link to={'/'}>
                          <MenuItem onClick={handleClose}>
                            <MenuIcon src={DashboardIcon} alt="Dashboard" />
                            Dashboard
                          </MenuItem>
                        </Link>
                        <StyledLink
                          href="https://www.blackspectacles.com/pricing"
                          target="_blank"
                        >
                          <MenuItem onClick={handleClose}>
                            <MenuIcon
                              src={MyCartIcon}
                              alt="Individual Pricing"
                            />
                            Individual Pricing
                          </MenuItem>
                        </StyledLink>
                        <StyledLink
                          href="https://help.blackspectacles.com/en/"
                          target="_blank"
                        >
                          <MenuItem onClick={handleClose}>
                            <MenuIcon src={HelpIcon} alt="Help" />
                            Help
                          </MenuItem>
                        </StyledLink>
                        <Divider />
                      </>
                    )}
                    {masterAccess ? (
                      <>
                        <Link to={'/profile/settings/manage'}>
                          <MenuItem onClick={handleClose}>
                            <MenuIcon
                              src={ManageSubscriptionIcon}
                              alt="Manage Subscription"
                            />
                            Manage Subscription
                          </MenuItem>
                        </Link>
                        <Link to={'/profile/settings/billing'}>
                          <MenuItem onClick={handleClose}>
                            <MenuIcon
                              src={PaymentMethodIcon}
                              alt="Payment Method"
                            />
                            Payment Method
                          </MenuItem>
                        </Link>
                        {!isCga && (
                          <Link to={'/profile/settings/history'}>
                            <MenuItem onClick={handleClose}>
                              <MenuIcon
                                src={BillingHistoryIcon}
                                alt="Billing History"
                              />
                              Billing History
                            </MenuItem>
                          </Link>
                        )}
                      </>
                    ) : null}
                    <Link to={'/profile/settings/update'}>
                      <MenuItem onClick={handleClose}>
                        <MenuIcon
                          src={UpdateProfileIcon}
                          alt="Update Profile"
                        />
                        Update Profile
                      </MenuItem>
                    </Link>
                    <Link to={'/profile/settings/change-password'}>
                      <MenuItem onClick={handleClose}>
                        <MenuIcon src={PasswordIcon} alt="Change Password" />
                        Change Password
                      </MenuItem>
                    </Link>
                    <Link to={'/profile/settings/are-progress'}>
                      <MenuItem onClick={handleClose}>
                        <MenuIcon
                          src={ExamStatusIcon}
                          alt="Report Exam Results"
                        />
                        Report Exam Results
                      </MenuItem>
                    </Link>
                    <MenuItem onClick={() => auth.logout()}>
                      <MenuIcon src={LogoutIcon} alt="Logout" />
                      Log Out
                    </MenuItem>
                  </StyledMenu>
                </Menu>
              </>
            )}
          </IconsBox>
        </RightBox>
      </NavbarBox>
      <MenuBox $isSideMenuExpanded={isSideMenuExpanded}>
        <Sidenav onClose={() => setIsSideMenuExpanded(false)} />
      </MenuBox>
    </>
  )
}

export default View
